export const addContactUsClickEventsToGTM = (action: string, label: string) => {
  dataLayer.push({
    Category: 'Contact Us',
    Action: action,
    Label: label,
    noninteraction: false,
    event: 'gaEvent',
  });
};
